import useGetDetailItem from "@hooks/Award/useGetAward";
import formMapper from "@mappers/Modules/award/AwardItem.mapper";
import updateItem from "@services/Award/updateAward";
import Modify from "@shared/FormTemplates/Modify";
import validator from "@validators/Modules/award/award.validate";
import { ReactElement } from "react";
import ModifyForm from "./ModifyForm";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
